import { TemplateElement, defineElement, html, i18n } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import ModalElementEvent from '../../../elements/_modal/modal-element/ModalElementEvent';

export default class ProductSeriesList extends TemplateElement {
    #modal = null;

    constructor() {
        super({ shadowRender: false, deferUpdate: true });
    }

    properties() {
        return {
            products: [],
            currentFrameId: false,
            url: '',
            gutterCss: '',
        };
    }

    connected() {
        this._description = this.$refs.description;
        // load Products when ussed in modal
        this.#modal = this.closest('modal-element');
        if (this.#modal.openState === true) {
            this.loadProducts();
        } else {
            this.#modal.addEventListener(ModalElementEvent.OPEN, () => this.loadProducts());
        }
        this.#modal.addEventListener(ModalElementEvent.OPEN, () => {
            this.#modal.$refs.content.scrollTop = 0;
        });
    }

    events() {
        return {
            '[ref=close]': {
                click: () => {
                    this.#modal.close();
                },
            },
        };
    }

    loadProducts() {
        if (this.products.length > 0) {
            return;
        }
        fetch(this.url)
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(({ products }) => {
                this.products = products;
            });
    }

    getDescription() {
        return html` <div>${unsafeHTML(this._description.outerHTML)}</div> `;
    }

    template() {
        return html`
            <div class="grid gird-cols-1 md:grid-cols-2 xl:grid-cols-3 ${this.gutterCss}">
                ${this.getDescription()}
                ${this.products.map(
                    product => html`
                        <product-card
                            current-frame-id="${this.currentFrameId}"
                            .frames="${product.frames}"
                            name="${product.name}"
                            description="${product.description}"
                        ></product-card>
                    `
                )}
            </div>
            <div class="flex my-4 md:my-8 lg:my-12 justify-center w-full">
                <button class="btn btn-outline-dark" ref="close">
                    <span>${i18n('productlist.backbtn.label', 'Zurück zur Serie')}</span>
                </button>
            </div>
        `;
    }
}
